// extracted by mini-css-extract-plugin
module.exports = {"shopifyGrantPricingWrapper":"ShopifyGrantPricing_shopifyGrantPricingWrapper__1zMe5"};